import { render, staticRenderFns } from "./EcTabelaListagem.vue?vue&type=template&id=3285db18&"
import script from "./EcTabelaListagem.vue?vue&type=script&lang=js&"
export * from "./EcTabelaListagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports